<template>
  <BaseChart
    height="250px"
    chart-height="150px"
    title="Percentage increase in original currency"
    :chart-data="mergedChartData"
    :subtitle="subtitle"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { merge, cloneDeep } from 'lodash'
import { commonPropertiesMixin } from './common-properties-mixin'
import { customChartData as baseChartData } from '@/reusable/base-chart/common-custom-chart-data'

const customChartData = merge(cloneDeep(baseChartData), {
  yAxis: {
    labels: {
      format: '{value} %'
    }
  }
})

export default {
  mixins: [
    commonPropertiesMixin(
      'price-increase-in-percentage-in-original-currency-compared-to-average-price-increase',
      customChartData
    )
  ],

  computed: {
    subtitle() {
      if (!this.supportData) return 'Original currency'
      return `Original currency (${this.supportData.merge_data['[[ CURRENCY ]]']})`
    }
  }
}
</script>
